import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import Spinner from '@components/spinner'

class EmailTracking extends Component {
  static propTypes = {
    projectStore: PropTypes.object,
    eplEmailStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    const { projectStore, eplEmailStore } = props
    const projectId = projectStore.project.id

    eplEmailStore.loadStatistics(projectId)
  }

  render () {
    const { eplEmailStore } = this.props
    const { loading, statistics, totals } = eplEmailStore

    if (loading) return <Spinner />

    const projectName = this.props.projectStore.project.projectName

    return (
      <DocumentTitle
        title={`${projectName} - email tracking | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <div className='story'>
            <span className='label'>Project email tracking</span>
            <table className='table-wrapper--nested'>
              <thead>
                <tr>
                  <th>Employee / Expert</th>
                  <th>Position / Company</th>
                  <th>Recipients</th>
                  <th>Sent</th>
                  <th>Delivered</th>
                  <th>Opened</th>
                  <th>Clicked</th>
                  <th>Applied</th>
                  <th>Declined</th>
                  <th>Submitted</th>
                  <th>Interviewed</th>
                  <th />
                </tr>
              </thead>
              {statistics.map(employeeStats => (
                <tbody key={employeeStats.employeeId}>
                  <tr className='title'>
                    <td className='bold'>{employeeStats.employeeFullName}</td>
                    <td />
                    <td>{employeeStats.recipients}</td>
                    <td>{employeeStats.sent}</td>
                    <td>{employeeStats.delivered}</td>
                    <td>{employeeStats.opened}</td>
                    <td>{employeeStats.clicked}</td>
                    <td>{employeeStats.applied}</td>
                    <td>{employeeStats.declined}</td>
                    <td>{employeeStats.submitted}</td>
                    <td>{employeeStats.interviewed}</td>
                    <td />
                  </tr>
                  {employeeStats.eplStatistics.map(eplStats => (
                    <tr key={eplStats.eplId} className=''>
                      <td>
                        <span className='text-wrapper'>
                          {eplStats.eplFullName}
                        </span>
                      </td>
                      <td>{eplStats.positionAtCompany}</td>
                      <td />
                      <td>{eplStats.sent}</td>
                      <td>{eplStats.delivered}</td>
                      <td>{eplStats.opened}</td>
                      <td>{eplStats.clicked}</td>
                      <td>{eplStats.applied}</td>
                      <td>{eplStats.declined}</td>
                      <td>{eplStats.submitted}</td>
                      <td>{eplStats.interviewed}</td>
                      <td>
                        <Link to={'epl-emails/' + eplStats.eplId}>
                          See emails
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ))}
              <tfoot>
                <tr className='title'>
                  <td>Total</td>
                  <td />
                  <td>{totals.recipients}</td>
                  <td>{totals.sent}</td>
                  <td>{totals.delivered}</td>
                  <td>{totals.opened}</td>
                  <td>{totals.clicked}</td>
                  <td>{totals.applied}</td>
                  <td>{totals.submitted}</td>
                  <td>{totals.interviewed}</td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('projectStore', 'eplEmailStore')(observer(EmailTracking))
